<div class="section">
  <p #explanation><ng-content></ng-content></p>
  <p *ngIf="! explanation.children.length">
    Please look for a link we sent to <strong data-pii>{{ email }}</strong> to confirm you are the owner of this email
    address before proceeding.
  </p>
</div>
<ng-container *ngIf="showSpinner">
  <div class="section">
    <dxo-circular-loader size="medium"></dxo-circular-loader>
  </div>
</ng-container>
<div class="section">
  <dxo-button
    class="text-button"
    [textButton]="true"
    (handleClick)="emitRequestResendMagicLink()"
    text="Resend a new link."
  ></dxo-button>
</div>

<div class="section">
  <dxo-button
    class="text-button"
    [textButton]="true"
    (handleClick)="emitRequestMfaAlternative()"
    text="I can't receive a link by email."
  ></dxo-button>
</div>
